import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <h1>404</h1>
          <h2>Page non trouvée</h2>
          <p>La page que vous recherchez n'existe pas ou a été déplacée.</p>
          <div className="not-found-actions">
            <Link to="/" className="btn-primary">
              <Home size={20} />
              Retour à l'accueil
            </Link>
            <button onClick={() => window.history.back()} className="btn-outline">
              <ArrowLeft size={20} />
              Page précédente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}